/**
 * description: 选择音频的弹出框
 * created by liu jinming
 * created on 2017.09.28
 */
"use strict";
angular.module('trsEditVideoServiceModule', [])
    .factory('trsEditVideoService', ["$modal", "trsHttpService", "$timeout", "modalDialog", "$sce", "$q", function($modal, trsHttpService, $timeout, modalDialog, $sce, $q) {
        function getVideoUrl(obj, videoId, type) {
            var deffer = $q.defer();
            var urlParams = {
                serviceid: 'mlf_videoInterfacesEncapsulation',
                methodname: 'getVideoUrl',
                VideoId: videoId,
                resourceType: type
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), urlParams, 'post').then(function(urlData) {
                var avurl = $sce.trustAsResourceUrl(urlData.DATA.videoUrl);
                obj.videoUrl = avurl;
                obj.orgVideoUrl = urlData.DATA.videoUrl;
                obj.duration = urlData.DATA.duration;
                obj.size = urlData.DATA.size;
                deffer.resolve(obj);
            });
            return deffer.promise;
        }
        return {
            trsEditVideoNew: function(AUDIOVIDEOID, METADATAID, name, type) {
                var deffer = $q.defer();
                var editParms = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'getKuaiBianAddress',
                    VideoId: AUDIOVIDEOID,
                    name: name || 'name',
                    docId: METADATAID,
                    resourceType: type
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), editParms, "post").then(function(data) {
                    if (!angular.isObject(data.DATA)) {
                        modalDialog.alertType(data.MSG, '', 'warning', 'confirm');
                        return;
                    }
                    var editUrl = data.DATA.url;
                    window.open(editUrl);
                    queryEditStatus(data.DATA.editId);

                    function queryEditStatus(id) {
                        var queryEParams = {
                            serviceid: 'mlf_videoInterfacesEncapsulation',
                            methodname: 'getEditStatus',
                            editId: id
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), queryEParams, 'post').then(function(resp) {
                            if (resp.DATA.length === 0 || resp.DATA.status === 0) {
                                $timeout(function() {
                                    queryEditStatus(id);
                                }, 5000);
                            } else if (resp.DATA.status === 1) {
                                var videoId = resp.DATA.newVideoId;
                                var zjVParams = {
                                    serviceid: 'mlf_videoInterfacesEncapsulation',
                                    methodname: 'getMediaFrame',
                                    mediaId: videoId,
                                    resourceType: type
                                };
                                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), zjVParams, 'post').then(function(data) {
                                    if (data.msg == "视频不存在") {
                                        modalDialog.alertType('', '视频资源无法找到请确认视频信息', 'error', true);
                                    } else {
                                        var url = data.DATA.mediaFrameUrl;
                                        var obj = { 'URL': url, 'videoId': videoId, "videoUrl": '' };
                                        getVideoUrl(obj, videoId, type).then(function(res) {
                                            deffer.resolve(res);
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
                return deffer.promise;
            }
        };
    }]);